import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getList, deleteUser, resetPassword } from '../../../api/user';
import authItem from '@blade/common/components/auth/auth-item.vue';
import { EventBus } from '@blade/common';
import colors from '@/styles/color.scss';
import { LoginModule } from '@blade/common/store/login';
import InvisibleNumber from '@blade/common/components/invisible-number.vue';
let default_1 = class default_1 extends Vue {
    form;
    colors = colors;
    loading = false;
    taskList = [];
    org_id = '';
    dateRange = ['', ''];
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    dialogVisible = false;
    viewDialogVisible = false;
    editUsers = {};
    userId = '';
    get init() {
        return LoginModule.privacyMode;
    }
    colorStyles(state) {
        if (state === 'DISABLE') {
            return `background:${colors.dodBlack}`;
        }
        else if (state === 'ENABLE') {
            return `background:${colors.greenText0}`;
        }
        else {
            return `background:${colors.dodOrange}`;
        }
    }
    goView(row) {
        this.$parent.addDialogVisible = true;
        this.$parent.type = 'detail';
        this.editUsers = row;
        let newDetailRow = { ...row };
        EventBus?.$emit('getuserDetail', newDetailRow);
    }
    formChange(form) {
        this.pagination.page = 1;
        this.getList({ ...form, org_id: '' });
    }
    handleSizeChange(val) {
        this.pagination.size = val;
        this.getList({});
    }
    handleCurrentChange(val) {
        this.pagination.page = val;
        this.getList({});
    }
    getList(params) {
        const userListParam = {
            page: this.pagination.page,
            size: this.pagination.size,
            org_id: this.org_id,
            ...params,
        };
        getList(userListParam)
            .then((res) => {
            this.loading = false;
            this.taskList = res.userVos ? res.userVos : [];
            const total = res.total_size;
            this.pagination.total = total;
        })
            .finally(() => {
            this.loading = false;
        });
    }
    /**
     *@Description: 删除任务
     */
    handleDelete(id) {
        let confirm = `${this.$t('common.confirm')}`;
        let deviceConfirmDelete = `${this.$t('deleteMsg')}`;
        this.$elconfirm(deviceConfirmDelete, `${this.$t('common.warning')}`, {
            type: 'warning',
            cancelButtonText: `${this.$t('common.no')}`,
            confirmButtonText: confirm,
            cancelButtonClass: 'cancel-roi-tip',
            confirmButtonClass: 'confirm-roi-tip',
            callback: (action) => {
                if (action === 'confirm') {
                    deleteUser(id)
                        .then(() => {
                        this.$message({
                            message: this.$t('deletedSuccessfully'),
                            type: 'success',
                        });
                        this.getList({});
                    })
                        .catch(() => { });
                }
            },
        });
    }
    /**
     *@Description: 编辑任务
     */
    handleEdit(row) {
        this.$parent.addDialogVisible = true;
        this.$parent.type = 'edit';
        this.editUsers = row;
        let newEditRow = { ...row };
        EventBus.$emit('getuserDetail', newEditRow);
    }
    async handleView(id) {
        await resetPassword(id)
            .then((res) => {
            this.$elconfirm(`${this.$t('password')}${res}`, `${this.$t('resetSuccess')}`, {
                type: 'success',
                showCancelButton: false,
                showConfirmButton: false,
                customClass: 'return-visit-message-box',
            });
        })
            .catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    mounted() {
        EventBus.$on('changeOrgId', (id) => {
            this.org_id = id;
            this.pagination.page = 1;
            this.getList({});
        });
        EventBus.$on('getUserList', () => {
            this.$parent.form = {};
        });
    }
};
__decorate([
    Prop()
], default_1.prototype, "form", void 0);
__decorate([
    Watch('form', { immediate: true, deep: true })
], default_1.prototype, "formChange", null);
default_1 = __decorate([
    Component({
        name: 'table',
        components: { authItem, InvisibleNumber },
        i18n: {
            messages: {
                zh: {
                    name: '名称',
                    role: '角色',
                    department: '部门',
                    mob: '电话',
                    status: '状态',
                    option: '操作',
                    view: '重置密码',
                    resetSuccess: '重置成功',
                    password: '密码重置为 ',
                    abnormal: '异常',
                    cancel: '取消',
                    delete: '确认',
                    deletedSuccessfully: '删除成功',
                    total: '总共 {msg} 条',
                    deleteMsg: '确定删除这个账户吗？',
                    effect: 'Enable',
                    noEffective: 'Disable',
                },
                'en-us': {
                    name: 'NickName',
                    role: 'Role',
                    department: 'Department',
                    mob: 'Mob',
                    status: 'Status',
                    option: 'Option',
                    view: 'Reset Password',
                    resetSuccess: 'Reset password succeeded',
                    password: 'Reset password to ',
                    abnormal: 'Abnormal',
                    cancel: 'Cancel',
                    delete: 'Delete',
                    deletedSuccessfully: 'Deleted successfully',
                    total: 'Total {msg} Items',
                    deleteMsg: 'Are you sure to delete this account?',
                    effect: 'Enable',
                    noEffective: 'Disable',
                },
            },
        },
    })
], default_1);
export default default_1;
